"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _index = _interopRequireDefault(require("keycode/index"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _styles = require("@mui/material/styles");
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = exports.styles = function styles(theme) {
  return {
    root: (0, _objectSpread2.default)({}, theme.typography.body3, {
      display: 'inline-flex',
      alignItems: 'center',
      marginRight: 4,
      width: 'fit-content',
      height: 24,
      borderRadius: 12,
      cursor: 'pointer',
      padding: '0 4px',
      outline: 'none',
      // No outline on focused element in Chrome (as triggered by tabIndex prop)
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      '&:hover, &:focus': {
        backgroundColor: (0, _styles.emphasize)('#e0e0e0', 0.08)
      }
    }),
    active: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.neutral.contrastText,
      '&:hover, &:focus': {
        backgroundColor: theme.palette.primary.dark
      }
    },
    inactive: {
      backgroundColor: '#e0e0e0',
      color: theme.palette.neutral.dark
    },
    icon: {
      color: theme.palette.neutral.main,
      marginRight: 5
    },
    iconActive: {
      color: theme.palette.neutral.contrastText
    },
    tags: {
      fontSize: 16,
      paddingRight: 4,
      paddingBottom: 4,
      paddingTop: 4,
      marginLeft: 4,
      float: 'left'
    },
    label: {
      userSelect: 'none',
      whiteSpace: 'nowrap'
    },
    noSelection: {
      marginRight: 4
    },
    selection: {
      height: 18,
      lineHeight: '20px',
      width: 24,
      borderRadius: 8,
      backgroundColor: 'white',
      justifyContent: 'center',
      color: theme.palette.neutral.dark,
      textAlign: 'center',
      marginLeft: 4,
      outline: 'none',
      // No outline on focused element in Chrome (as triggered by tabIndex prop)
      cursor: 'auto'
    },
    selectionClickable: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: '#e0e0e0'
      }
    }
  };
};
var HiChipSwitch = /*#__PURE__*/function (_React$PureComponent) {
  function HiChipSwitch(props) {
    var _this;
    (0, _classCallCheck2.default)(this, HiChipSwitch);
    _this = _callSuper(this, HiChipSwitch, [props]);
    _this.chipSwitchRef = null;
    _this.handleKeyDown = function (event) {
      // Ignore events from children of `Chip`.
      if (event.currentTarget !== event.target) {
        return;
      }
      var _this$props = _this.props,
        onClick = _this$props.onClick,
        onKeyDown = _this$props.onKeyDown;
      var key = (0, _index.default)(event);
      if (onClick && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onClick(event);
      } else if (key === 'esc') {
        event.preventDefault();
        if (_this.chipSwitchRef) {
          _this.chipSwitchRef.blur();
        }
      }
      if (onKeyDown) {
        onKeyDown(event);
      }
    };
    _this.handleKeyDownSelection = function (event) {
      var onSelectionClick = _this.props.onSelectionClick;
      var key = (0, _index.default)(event);
      if (onSelectionClick && (key === 'space' || key === 'enter')) {
        event.preventDefault();
        onSelectionClick(event);
      }
    };
    _this.handleClickSelection = _this.handleClickSelection.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleKeyDownSelection = _this.handleKeyDownSelection.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(HiChipSwitch, _React$PureComponent);
  return (0, _createClass2.default)(HiChipSwitch, [{
    key: "handleClickSelection",
    value: function handleClickSelection(event) {
      if (this.props.onSelectionClick) {
        if (event) {
          event.stopPropagation();
        }
        this.props.onSelectionClick();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        id = _this$props2.id,
        label = _this$props2.label,
        classes = _this$props2.classes,
        activeIcon = _this$props2.activeIcon,
        active = _this$props2.active,
        onClick = _this$props2.onClick,
        onSelectionClick = _this$props2.onSelectionClick,
        selection = _this$props2.selection,
        selectionTitle = _this$props2.selectionTitle;
      var selectionProps = {
        tabIndex: '-1'
      };
      if (onSelectionClick && selection !== 0) {
        selectionProps = {
          onClick: this.handleClickSelection,
          role: 'button',
          tabIndex: '0',
          onKeyDown: this.handleKeyDownSelection,
          title: selectionTitle
        };
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.active, !!active), classes.inactive, !active)),
        onClick: onClick,
        role: "button",
        tabIndex: "0",
        onKeyDown: this.handleKeyDown,
        ref: function ref(node) {
          _this2.chipRef = node;
        }
      }, /*#__PURE__*/_react.default.createElement(_HiIcon.default, {
        icon: active ? activeIcon : 'add',
        size: 20,
        className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconActive, !!active))
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)(classes.label, (0, _defineProperty2.default)({}, classes.noSelection, selection === null))
      }, label), selection !== null && /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
        className: (0, _classnames.default)(classes.selection, (0, _defineProperty2.default)({}, classes.selectionClickable, onSelectionClick && selection !== 0))
      }, selectionProps), selection));
    }
  }]);
}(_react.default.PureComponent);
HiChipSwitch.defaultProps = {
  active: false,
  activeIcon: 'check',
  selection: null,
  selectionTitle: ''
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiChipSwitch'
})(HiChipSwitch);